export default function BacktestKpis() {
  return (
    <div className="tableWrap">
      <table className="dataTable">
        <thead>
          <tr>
            <th>Metric</th>
            <th>Value</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Trades</td><td>141</td><td>Trade days</td></tr>
          <tr><td>Win Rate</td><td>—</td><td>Compute soon</td></tr>
          <tr><td>Avg Win</td><td>—</td><td>Compute soon</td></tr>
          <tr><td>Avg Loss</td><td>—</td><td>Compute soon</td></tr>
          <tr><td>Profit Factor</td><td>—</td><td>Compute soon</td></tr>
          <tr><td>Max DD ($)</td><td>$24,200</td><td>From Kelly replay</td></tr>
          <tr><td>Max DD (%)</td><td>34.24%</td><td>From Kelly replay</td></tr>
        </tbody>
      </table>

      <div className="tableFootnote">
        Backtest statistics will be populated once calculations are finalized.
      </div>
    </div>
  );
}
